import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-thunder-move-icon',
  templateUrl: './general-thunder-move.component.html'
})
export class GeneralThunderMoveComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
